module.exports = __webpack_public_path__ + "static/media/show-gal-3.2eb4116a.jpg";